import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUseIsMaintenanceQueryOptions } from "../../../maintenance-check-point/queries/useIsMaintenanceQuery";
import { getStreets } from "../api/getStreets";
import { StreetModel } from "../models/StreetModel";

export const getStreetQueryKey = ["ulice"];

export const useStreetsQuery = () => {
  const client = useQueryClient();
  return useQuery<StreetModel[]>(getStreetQueryKey, () => {
    client.prefetchQuery(...getUseIsMaintenanceQueryOptions);
    return getStreets();
  });
};
